import { useEffect } from "react";
import Hero from "@/components/de/Hero";
import AboutSection from "@/components/de/AboutSection";
import DonationSection from "@/components/de/DonationSection";
import Footer from "@/components/de/Footer";

const IndexDE = () => {
  useEffect(() => {
    const title = "NeuroResearch Foundation - Forschung zu neurologischen Erkrankungen";
    const description = "Stiftung für die Erforschung neurologischer Erkrankungen: Chronische Schmerzen, Alzheimer, Parkinson und ALS. Spenden Sie für innovative Behandlungsforschung. Wir unterstützen Patientenverbände in ganz Europa, darunter seltene Krankheiten in Spanien und Portugal. Wir freuen uns, die Forschung zum ECS-System und Neuro-Konnektoren zu unterstützen.";
    
    document.title = title;
    
    const updateMeta = (selector: string, attr: string, value: string) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        if (selector.includes('property=')) {
          el.setAttribute('property', selector.match(/property="([^"]+)"/)?.[1] || '');
        } else if (selector.includes('name=')) {
          el.setAttribute('name', selector.match(/name="([^"]+)"/)?.[1] || '');
        }
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="og:locale"]', 'content', 'de_DE');
    updateMeta('meta[property="og:type"]', 'content', 'website');
  }, []);

  return (
    <div className="min-h-screen">
      <Hero />
      <AboutSection />
      <DonationSection />
      <Footer />
    </div>
  );
};

export default IndexDE;
